export const converteCSTPisCofinsXML = (
  cstXML: string | null,
  flgIgnoraPisCofins: boolean,
  cstProduto: string,
  fornIntrPISCof: boolean,
  tipoNF: number,
): any => {
  let result = '';

  switch (cstXML) {
    case '01':
    case '02':
      result = '50';
      break;
    case '04':
      result = '70';
      break;
    case '05':
      result = '75';
      break;
    case '06':
      result = '73';
      break;
    case '07':
      result = '71';
      break;
    case '09':
      result = '72';
      break;
    default:
      if (fornIntrPISCof) {
        result = '70';
      } else if (flgIgnoraPisCofins) {
        result = '';
      } else if (tipoNF === 11) {
        result = '98';
      } else {
        result = cstProduto;
      }
  }

  return result;
};
